import {
  Box,
  Grid,
  Stack,
  StackProps,
  Typography
} from "@mui/material";
import { common } from "@mui/material/colors";
import {
  alpha,
  styled
} from "@mui/material/styles";
import { ElementType } from "react";

export const HeroCardStack = styled(Stack)<
  & StackProps
  & {
    $topImageVisible?: boolean
    $coverPublicURL: string
    component: ElementType // monkeypatch to fix property 'component' does not exist on type 'intrinsicattributes'
  }
>(({ theme }) => ({
  background: theme.palette.background?.paper ?? "#ffffff",
  borderRadius: "12px",
  boxShadow: theme.shadows[4],
  flexDirection: "row",
  marginBottom: theme.spacing(6),
  maxWidth: "100%",
  minHeight: "450px",
  overflow: "hidden",

  [theme.breakpoints.down("sm")]: {
    borderRadius: "8px",
    boxShadow: "none",
    flexDirection: "column",
    marginLeft: "-20px",
    marginRight: "-20px",
    minHeight: "auto",
    minWidth: "100%"
  }
}));

export const ImageSection = styled(Box)<{ $coverPublicURL: string }>(({ $coverPublicURL, theme }) => ({
  backgroundImage: `url(${$coverPublicURL})`,
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "contain", // Cambiato da "cover" a "contain" per mostrare l'immagine per intero
  flex: "1 1 50%",
  minHeight: "450px",

  [theme.breakpoints.down("sm")]: {
    backgroundSize: "contain", // Mantiene "contain" anche su mobile
    flex: "none",
    minHeight: "280px",
    width: "100%"
  }
}));

export const TextGrid = styled(Grid)(({ theme }) => ({
  background: `${theme.linearGradients.gradientC}`,
  display: "flex",
  flex: "1 1 50%",
  flexDirection: "column",
  gap: theme.spacing(3),
  justifyContent: "center",
  padding: theme.spacing(4),

  "> button": {
    width: "fit-content"
  },

  [theme.breakpoints.down("sm")]: {
    alignItems: "center",
    background: `${theme.linearGradients.gradientC}`,
    flex: "none",
    gap: theme.spacing(2),
    justifyContent: "center",
    padding: theme.spacing(1),
    textAlign: "center",
    width: "100%",

    "> button": {
      width: "fit-content"
    }
  }
}));

export const TitleTypography = styled(Typography)(({ theme }) => ({
  fontSize: "1.5rem",
  fontWeight: "700",
  lineHeight: 7 / 6,
  textShadow: `0 0 1.25rem ${alpha(theme.palette.background?.paper ?? common["black"], 0.25)}`,

  [theme.breakpoints.down("sm")]: {
    fontSize: "1.5rem",
    textAlign: "center",
    textWrap: "balance"
  }
}));

export const DetailTypography = styled(Typography)(({ theme }) => ({
  fontSize: "1rem",
  lineHeight: 1.1875,

  [theme.breakpoints.down("sm")]: {
    fontSize: "1rem",
    marginBottom: "8px",
    textAlign: "center"
  }
}));
